import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Star, MapPin, BadgeCheck } from "lucide-react";
import { Layout } from "../components/Layout";
import { DogCard } from "../components/DogCard";
import api from "../lib/api";

export default function BreederDetail() {
  const { id } = useParams();
  const [b, setB] = useState(null);
  useEffect(() => { api.get(`/breeders/${id}`).then((r) => setB(r.data)); }, [id]);
  if (!b) return <Layout><div className="max-w-[1400px] mx-auto px-5 py-32 text-eon-muted">Loading...</div></Layout>;
  return (
    <Layout>
      <section className="relative h-[42vh] overflow-hidden">
        <img src={b.image} alt={b.business_name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-eon-bg to-eon-bg/30" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-8 h-full flex flex-col justify-end pb-10">
          <span className="eon-label mb-2">{b.tier} Breeder</span>
          <h1 className="eon-heading text-4xl lg:text-6xl uppercase flex items-center gap-3">{b.business_name} {b.tier !== "free" && <BadgeCheck className="text-eon-gold" size={32} />}</h1>
          <div className="flex items-center gap-4 mt-3 text-sm text-eon-text/80">
            <span className="flex items-center gap-1"><MapPin size={14} /> {b.location}</span>
            {b.review_count > 0 && <span className="flex items-center gap-1"><Star size={14} className="text-eon-gold fill-eon-gold" /> {b.rating} ({b.review_count} reviews)</span>}
          </div>
        </div>
      </section>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-12">
        <div className="max-w-3xl mb-12">
          <div className="eon-label mb-3">About</div>
          <p className="text-lg text-eon-text/80 leading-relaxed">{b.about}</p>
          <div className="flex flex-wrap gap-2 mt-5">{b.breeds.map((br) => <span key={br} className="eon-label border border-eon-border px-3 py-1.5">{br}</span>)}</div>
        </div>
        <h2 className="eon-heading text-3xl uppercase mb-8">Current Listings</h2>
        {b.dogs?.length ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">{b.dogs.map((d, i) => <DogCard key={d.id} dog={d} index={i} />)}</div>
        ) : (
          <div className="border border-eon-border rounded-2xl p-12 text-center">
            <div className="eon-label mb-2">Coming Soon</div>
            <h3 className="font-display text-2xl font-bold text-eon-text">Puppies Coming Soon</h3>
            <p className="text-sm text-eon-muted mt-2 max-w-md mx-auto">No puppies are listed yet. Join the waitlist to be first to know when the next litter is announced.</p>
            <Link to="/dogs" className="inline-block mt-5 rounded-full bg-eon-gold text-white text-xs font-bold uppercase tracking-wider px-5 py-3 hover:bg-eon-goldhover transition-colors" data-testid="breeder-waitlist-link">Join the Puppy Waitlist</Link>
          </div>
        )}
      </div>
    </Layout>
  );
}
